module.exports = __webpack_public_path__ + "img/razzo3.320984ae.png";